/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface LoginRequestContent
 */
export interface LoginRequestContent {
    /**
     * 
     * @type {string}
     * @memberof LoginRequestContent
     */
    playerNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestContent
     */
    lastName?: string;
}


/**
 * Check if a given object implements the LoginRequestContent interface.
 */
export function instanceOfLoginRequestContent(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function LoginRequestContentFromJSON(json: any): LoginRequestContent {
    return LoginRequestContentFromJSONTyped(json, false);
}

export function LoginRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'playerNumber': !exists(json, 'playerNumber') ? undefined : json['playerNumber'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
    };
}

export function LoginRequestContentToJSON(value?: LoginRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'playerNumber': value.playerNumber,
        'lastName': value.lastName,
    };
}

